<template>
  <quill-editor ref="editor"
                style="font-family: 'NotoKrR'"
                :style="{height}"
                :toolbar="customToolbar"
                :modules="editorModules"
                :content-type="'html'"
                v-model:content="cn"
                @textChange="cn_change"/>
</template>

<script setup>
import Quill from 'quill';
import { QuillEditor } from '@vueup/vue-quill';
import ImageUploader from "quill-image-uploader";
import '@vueup/vue-quill/dist/vue-quill.snow.css';

import {onBeforeMount, ref, defineProps, nextTick, defineExpose} from "vue";
import {getUtils, getStore} from "@/utils/import";
const {$loading} = getStore();
const {$file, $alert, $cmmn} = getUtils();

// Quill ImageUploader 모듈 등록
Quill.register('modules/imageUploader', ImageUploader);

const props = defineProps({
  cn: {
    type: String,
    default: '',
  },
  height: {
    type: String,
    default: '500px'
  },
  max: {
    type: Number,
    default: 30000
  },
  cnImgFiles: {
    type: Array,
    default: () => []
  }
});

const cn = ref('');
const cnLength = ref(0);

const customToolbar = [
  'bold',
  'underline',
  {'color': []},
  {'align': ['', 'center', 'right']},
  'image',
  'link'
]

const editorModules = {
  module: ImageUploader,
  options: {
    upload: file => {
      return new Promise(  (resolve, reject) => {
        uploadFile(file)
          .then(res => {
            resolve(res);
          }).catch(err => {
            reject("Upload failed");
            console.error("Error:", err)
          })
      });
    }
  }
}

const editor = ref(null);
const cn_change = async ({delta}) => {
  let cnLt = cn.value.length;

  delta.ops.forEach((info) => {
    if (info.insert) {
      if (typeof (info.insert.image) != 'undefined' &&
              info.insert.image.indexOf('loadImageFile') < 0) {
        cnLt -= info.insert.image.length;
        cnLt += 100;
      }
    }
  });

  if (cnLt > props.max) {
    editor.value.getQuill().history.undo();
    await $alert('내용은 ' + props.max + 'byte 이상으로 작성 하실 수 없습니다.');
    return false;
  }

  cnLength.value = cnLt;
}

const cnImgFiles = ref([]);
const uploadFile = async (file) => {
  try {
    $loading.on();

    const options = {
      imgResize: {
        is: false,
        maxSize: 720,
      }
    };

    const fileInfo
            = await $file.ncp.tmp.upld(file, options);

    const dwldUrl = await $file.ncp.tmp.getDwldUrl(fileInfo.objectName);

    fileInfo.se = 'new';
    fileInfo.dwldUrl = dwldUrl;
    cnImgFiles.value.push(fileInfo);

    return dwldUrl;
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const getCnAndFiles = () => {
  // 내용에서 삭제된 이미지 + 업로드할 이미지 체크
  const dltCnImgFiles = cnImgFiles.value.filter((img) => img.se == 'old' && cn.value.indexOf(img.flnm) == -1);
  const upldCnImgFils = cnImgFiles.value.filter((img) => img.se == 'new' && cn.value.indexOf(img.flnm) > -1);

  // 저장할 이미지 바꿔줌 => dwldUrl -> flnm으로 변경
  let setCn = cn.value;
  cnImgFiles.value.forEach((file) => {
    setCn = setCn.replaceAll(file.dwldUrl, file.flnm);
  });

  return {
    cn: setCn,
    upldCnImgFils,
    dltCnImgFiles,
  };
}

onBeforeMount(async () => {
  await nextTick(() => {
    if (props.cn) {
      cn.value = props.cn;
      cnLength.value = props.cn.length;
      editor.value.setHTML(cn.value);
    }

    if (props.cnImgFiles) {
      props.cnImgFiles.forEach((file) => file.se = 'old');
      cnImgFiles.value = props.cnImgFiles;
    }
  })
});

defineExpose({
  getCnAndFiles
})
</script>

<style scoped>
</style>
